import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { ActivatedRoute, Router } from '@angular/router';
import { from, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { EventResource } from 'src/app/interfaces/event-resource';
import { NewsItemResource } from 'src/app/interfaces/news-item-resource';
import { PagedResources } from 'src/app/interfaces/paged-resources';
import { EventService } from 'src/app/services/event.service';
import { NewsService } from 'src/app/services/news.service';
import { OverlayService } from 'src/app/services/overlay.service';
import { PushService } from 'src/app/services/push.service';


@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddPushMessageComponent implements OnInit {
  optionsAuto = [];
  /***
   * The Control for the Filter
   */
  myControl = new UntypedFormControl();
  /**
   * The Form to add a new PushMessage
   */
  addForm: UntypedFormGroup;
  /**
   * The  News / Events / APPOINTMENTs to be selected filtered
   */
  filteredOptions: Observable<string[]>;
  /**
   * The  News / Events / APPOINTMENTs to be selected
   */
  options = [];
  /**
   * The types of PushMessages
   */
  typesOfPushMessages = [
    { value: 'NEWS', viewValue: 'Infobeitrag' },
    { value: 'APPOINTMENT', viewValue: 'Veranstaltung' },
    { value: 'EVENTS', viewValue: 'Aktion' },
    { value: 'NO_REF', viewValue: 'Startseite' }
  ];
  /**
   * Is the Form submitted
   */
  submitted: boolean = false;
  /**
   * The Current Event => set via URL
   */
  currentEvent: EventResource;
  /**
   * Is the select for the Link disalbed (0 Events able for link)
   */
  disablelink: boolean = false;
  /**
   * constructor
   * Init the Form
   * @param fb 
   * @param eventService 
   * @param push 
   * @param overlayService 
   * @param router 
   * @param route 
   * @param newsService 
   */
  constructor(
    private fb: UntypedFormBuilder,
    private eventService: EventService,
    private push: PushService,
    private overlayService: OverlayService,
    private router: Router,
    private route: ActivatedRoute,
    private newsService: NewsService) {
    this.addForm = this.fb.group({
      type: ['', [Validators.required]],
      eventID: ['', []],
      date: ['', [Validators.required]],
      time: ['', [Validators.required]],
      text: ['', [Validators.required, Validators.maxLength(1024)]],
    })
  }
  /**
   * Get the eventPublicId vai URL and set currentEvent
   * 
   */
  ngOnInit(): void {
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value)),
    );
    }
  /**
   * Create a new PushMessage
   * @returns 
   */
  createPush() {
    this.addForm.markAllAsTouched();
    this.submitted = true;
    console.log(this.addForm)
    if (this.addForm.invalid) {
      return
    }

    //Convert Date to UNIX TimeFormat
    let t = new Date(this.addForm.value.date)
    const chars = this.addForm.value.time.split(':')
    t.setHours(chars[0])
    t.setMinutes(chars[1])
    let unix = Number(Math.floor(t.getTime() / 1000) + '000');

    let tempPush = {
      message: this.addForm.value.text,
      refPublicId: this.addForm.value.eventID,
      sendingOn: unix,
      type: this.addForm.getRawValue().type,
    }

    console.log(tempPush)
    
    this.push.createPushMessage(tempPush).subscribe({
      next: fromCreate => {
        this.overlayService.openSnackBar("Push Nachricht erfolgreich angelegt!");
        this.router.navigate(['../caseworker/pushmessages']);
      },
      error: (error: HttpErrorResponse) => {
        if (error?.error?.message != undefined) {
          this.overlayService.openSnackBar(error.error.message)
        } else {
          this.overlayService.openSnackBar("Es ist ein unerwarteter Fehler aufgetreten, bitte versuchen Sie es erneut.")
        }
      }
    })
  }

  /**
   * Get the News / Events / APPOINTMENTs based on the selct 
   */
  typeChange() {
    this.options = [];
    this.myControl.reset();
    this.disablelink = false;
    this.myControl.enable();
    if (this.addForm.getRawValue().type == 'NEWS') {
      this.addForm.controls['eventID'].addValidators(Validators.required);
      this.newsService.searchForNews(0, 99, "", null, ["NEWS"], null).subscribe((val: PagedResources<NewsItemResource>) => {
        if (val.content.length == 0) {
          this.disablelink = true;
          this.myControl.disable();
        } else {
          val.content.forEach(element => {
            this.optionsAuto.push({ value: element, viewValue: element.title });
          });
        }
      })
    } else if (this.addForm.getRawValue().type == 'EVENTS') {
      this.addForm.controls['eventID'].addValidators(Validators.required);
      this.eventService.searchForEvents(0, 999, ['ACTIVE', 'PREVIEW'], null, null, "").subscribe((val: PagedResources<NewsItemResource>) => {
     
        if (val.content.length == 0) {
          this.disablelink = true;
          this.myControl.disable();
        } else {
          val.content.forEach(element => {
            this.optionsAuto.push({ value: element, viewValue: element.title });
          });
        }
      })
    } else if (this.addForm.getRawValue().type == 'APPOINTMENT') {
         this.addForm.controls['eventID'].addValidators(Validators.required);
      this.newsService.searchForNews(0, 99, "", null, ["APPOINTMENT"], null).subscribe((val: PagedResources<NewsItemResource>) => {
        if (val.content.length == 0) {
          this.disablelink = true;
          this.myControl.disable();
        } else {
          val.content.forEach(element => {
            this.optionsAuto.push({ value: element, viewValue: element.title });
          });
        }
      })
    }else if (this.addForm.getRawValue().type == 'NO_REF') {
      this.addForm.controls['eventID'].removeValidators(Validators.required);
    }
  }
  /**
   * Format the Date => YYYY:MM:DD
   * @param date 
   * @returns 
   */
  private formatDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }
  /**
   * Formate the Time => HH:mm
   * @param date 
   * @returns 
   */
  private formatTime(date: Date) {
    const d = new Date(date);
    return [d.getHours(), d.getMinutes()].join(':');
  }
  /**
   * Get the News / Events / APPOINTMENTs
   * @param value 
   * @returns 
   */
  private _filter(value: string): string[] {
    this.optionsAuto = [];
    if (typeof (value) != 'object') {
      if (this.addForm.value.type == 'NEWS') {
        this.newsService.searchForNews(0, 99, value, null, ["NEWS"], null).subscribe((val: PagedResources<NewsItemResource>) => {
          val.content.forEach(element => {
            this.optionsAuto.push({ value: element, viewValue: element.title });
          });
        })
      } else if (this.addForm.value.type == 'EVENTS') {
        this.eventService.searchForEvents(0, 999, ['ACTIVE', 'PREVIEW'], null, null, value).subscribe((val: PagedResources<NewsItemResource>) => {
          val.content.forEach(element => {
            this.optionsAuto.push({ value: element, viewValue: element.title });
          });
        })
      } else if (this.addForm.value.type == 'APPOINTMENT') {
        this.newsService.searchForNews(0, 99, value, null, ["APPOINTMENT"], null).subscribe((val: PagedResources<NewsItemResource>) => {
          val.content.forEach(element => {
            this.optionsAuto.push({ value: element, viewValue: element.title });
          });
        })
      }
      return this.optionsAuto;
    }

  }


  getOptionTextNEWS(option: any) {
    return option?.title
  }

  getOptionTextEvents(option: any) {
    return option?.title
  }

  getOptionTextAPPOINTMENT(option: any) {
    return option?.title
  }

  setActiveNews(event: MatAutocompleteSelectedEvent) {
    this.addForm.patchValue({
      eventID: this.myControl.value.publicId,
    })
  }
  setActiveEvents(event: MatAutocompleteSelectedEvent) {
    this.addForm.patchValue({
      eventID: this.myControl.value.publicId,
    })
  }

  setActiveAppointments(event: MatAutocompleteSelectedEvent) {
    this.addForm.patchValue({
      eventID: this.myControl.value.publicId,
    })
  }
}
